import { stillWanted } from "./components/Kit";

/*
 * A handful of confetti for a moment worth one (prototype core.js celebrate, v2.20): 今天赚了 and ahead of yesterday
 * the first time 今天 is opened in a day, a follow-up tag done for the day. canvas-confetti draws on a canvas of its
 * own over everything and takes it away when the pieces have fallen; it is fetched the first time it is wanted. The
 * meeting-room screen has fireworks instead (celebration.ts): 「烟花不要彩纸」 (owner 9/28) was said of that screen.
 */

type Fire = (o: { particleCount: number; spread: number; startVelocity?: number; scalar?: number; angle?: number; origin?: { x?: number; y?: number }; colors: string[] }) => unknown;
const COLORS = ["#14A363", "#F2B807", "#7C5CFF", "#2F7BF6", "#EF5350", "#2DD4BF"];

function fire(confetti: Fire, kind: "small" | "big", origin?: { x?: number; y?: number }) {
  if (kind === "big") {
    confetti({ particleCount: 150, spread: 100, startVelocity: 45, origin: { y: 0.6 }, colors: COLORS });
    window.setTimeout(() => confetti({ particleCount: 80, angle: 60, spread: 70, origin: { x: 0, y: 0.7 }, colors: COLORS }), 250);
    window.setTimeout(() => confetti({ particleCount: 80, angle: 120, spread: 70, origin: { x: 1, y: 0.7 }, colors: COLORS }), 420);
  } else confetti({ particleCount: 70, spread: 75, startVelocity: 32, scalar: 0.9, origin: origin ?? { y: 0.6 }, colors: COLORS });
}

/** `origin`: where on the screen it bursts from, 0–1 across and down. Nothing for a reader who asked for less motion. */
export function celebrate(kind: "small" | "big" = "small", origin?: { x?: number; y?: number }) {
  if (stillWanted() || document.hidden) return;
  void import("canvas-confetti").then((m) => fire(m.default as unknown as Fire, kind, origin)).catch(() => undefined);
}
